/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-17 15:32:48
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-05-07 21:53:15
 * @FilePath: /seller-station-client/src/common/mall/Header/index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { useEffect, useRef, useState } from 'react';
import { Dropdown, MenuProps } from 'antd';
import { createSearchParams, useNavigate } from 'react-router-dom';
import './index.scss';
import { useAsyncEffect, useMount } from 'ahooks';
import { request } from '@/config/request';

interface HeaderProps {
	/** 是否来自搜索页面 */
	isFromSearch?: boolean;
	/** 输入框的默认值 */
	defaultKeyword?: string;
	/** 默认的分类ID */
	defaultCategoryId?: string;
	/** 如果来自搜索页那么回传参数 */
	fromSearchChange?: (params: HeaderSearchProps) => void;
}

export interface HeaderSearchProps {
	keyword: string;
	productCategoryFrontendId: string;
	categoryName: string;
}

/** 后端要求获取channel = 2 的数据 */
const CATEGORY_GET_DATA_FORM_CHANNEL = 2;

/** 自己造的all的分类值 */
export const CATEGORY_ALL_VALUE = 'All';

/** input输入框的默认值 */
const INPUT_PLACE_HOLDER = 'Women shoes';

interface procressListProps {
	key?: string;
	name?: string;
	productCategoryFrontendId?: string;
	label?: React.ReactNode;
	onClick: () => void;
}

const Header = (props: HeaderProps) => {
	const {
		isFromSearch,
		defaultKeyword,
		defaultCategoryId,
		fromSearchChange
	} = props;
	const navigate = useNavigate();
	const inputRef = useRef<any>();
	/** 搜索的默认值 */
	const [searchText, setSearchText] = useState(defaultKeyword ?? '');
	/** 选择的分类ID。如果是all那么是all */
	const [currentChoosedClassId, setCurrentChoosedClassId] = useState(
		defaultCategoryId ?? CATEGORY_ALL_VALUE
	);
	/** 处理返回的分类列表 */
	const [procressList, setProcressList] = useState<procressListProps[]>([]);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	// 手动触发分类id。如果来自搜索页面，那么触发父级的函数
	const handChangeCategoryId = (categoryId: string, categoryName: string) => {
		setCurrentChoosedClassId(categoryId);
		if (isFromSearch) {
			fromSearchChange?.({
				keyword: inputRef.current?.value ?? '',
				productCategoryFrontendId: categoryId,
				categoryName
			});
		}
	};

	useAsyncEffect(async () => {
		const res = await request.goods.productCategoryFrontend.tree({});
		const categoryList = (res.data ?? []).filter(
			(item) => item.channel === CATEGORY_GET_DATA_FORM_CHANNEL
		);
		if (categoryList.length) {
			const resultCategoryList = [
				{
					cateNameEn: CATEGORY_ALL_VALUE,
					productCategoryFrontendId: CATEGORY_ALL_VALUE
				},
				...(categoryList[0].productCategoryFrontendShortRespDTOList ??
					[])
			];

			const lastResultCategoryList = resultCategoryList.map((item) => {
				return {
					key: item.cateNameEn,
					name: item.cateNameEn,
					productCategoryFrontendId: String(
						item.productCategoryFrontendId ?? ''
					),
					label: (
						<div
							className={`text-[14px] leading-[22px] text-[#000] font-[400] hover:font-[900] hover:bg-[#F5F5F5]`}
						>
							{item.cateNameEn}
						</div>
					),

					onClick: () => {
						handChangeCategoryId(
							String(item?.productCategoryFrontendId ?? ''),
							item.cateNameEn ?? ''
						);
					}
				};
			});
			setProcressList(lastResultCategoryList);
		}
	}, []);

	const categoryName = (procressList ?? []).find(
		(item) => item.productCategoryFrontendId === currentChoosedClassId
	)?.name;

	const handleGoToSearchPage = () => {
		const params = {
			keyword: searchText,
			productCategoryFrontendId: currentChoosedClassId,
			categoryName: categoryName ?? ''
		};
		if (isFromSearch) {
			fromSearchChange?.(params);
			navigate(
				`/search?keyword=${searchText}&productCategoryFrontendId=${currentChoosedClassId}&categoryName=${categoryName}`,
				{
					replace: true
				}
			);
			return;
		}
		navigate({
			pathname: '/search',
			search: `?${createSearchParams(params)}`
		});
	};

	const goToSourcePage = () => {
		navigate('/source');
	};
	return (
		<div className="w-[1200px] h-[48px] mt-[24px] flex items-center justify-between m-auto ">
			<img
				onClick={goToSourcePage}
				alt="Source"
				src="https://static-us.theckb.com/static-asset/images/Source.svg"
				className="w-[320px] h-[40px] cursor-pointer"
			/>

			<div className="w-[640px] h-[100%] px-[4px] flex items-center box-border rounded-[26px] bg-[rgba(0,0,0,0.04)]">
				<Dropdown
					className="custom-user"
					menu={{
						items: procressList as any
					}}
					placement="bottomLeft"
					overlayClassName="custom-user"
					onOpenChange={(open) => {
						console.log(open, 'open');
						setDropdownOpen(open);
					}}
				>
					<div className="group max-w-[148px] cursor-pointer px-[24px] h-[40px] bg-[#fff] rounded-full flex justify-center items-center text-[14px] font-[900]">
						<span className="text-[14px] line-clamp-1 leading-[22px] font-[900]">
							{currentChoosedClassId === CATEGORY_ALL_VALUE
								? CATEGORY_ALL_VALUE
								: categoryName}
							{dropdownOpen}
						</span>
						<img
							alt="arrow"
							src="https://static-us.theckb.com/static-asset/images/class-arrow-down.png"
							className={`w-[12px] h-[12px] ml-[4px] ${dropdownOpen && 'group-hover:transition-all group-hover:rotate-180'}`}
						/>
					</div>
				</Dropdown>
				<div className="flex-1 h-[100%]">
					<input
						ref={inputRef}
						value={searchText}
						onChange={(value) => {
							setSearchText(value.target.value);
						}}
						className="w-[100%] outline-0 pl-[16px] h-[100%] bg-[transparent]"
					/>
				</div>
				<div
					onClick={handleGoToSearchPage}
					className="w-[64px] h-[40px] cursor-pointer rounded-full bg-absolute-13 hover:bg-[#1F1F1F] flex justify-center items-center"
				>
					<img
						alt="scale"
						src="https://static-us.theckb.com/static-asset/images/scale.png"
						className="w-[16px] h-[16px]"
					/>
				</div>
			</div>
		</div>
	);
};

export default Header;
